import { defineStore } from 'pinia'
import { ref } from 'vue'
import { type Title, TitleApi } from '@/api-swagger'
import { withApiState } from '@/utils/withApiState'

export const useTitleStore = defineStore('title', () => {
  const titles = ref<Title[] | null>(null)
  const loading = ref(false)
  const error = ref<string | null>(null)
  const api = new TitleApi()

  // Méthode pour récupérer les titres
  const getTitles = async () => {
    await withApiState(
      async () => {
        await api
          .getTitles()
          .then((res) => {
            titles.value = res
          })
          .catch((err) => {
            error.value = 'Titres non trouvés.'
          })
      },
      { loading, error, logLabel: 'Erreur API :' },
    )
  }

  return {
    titles,
    loading,
    error,
    getTitles: getTitles,
  }
})
